<dx-popup
    #manageWorkAuthorizationPopup
    minWidth="150px"
    minHeight="150px"
    width="55%"
    height="92%"
    [title]="workOrderTitle"
    [showTitle]="true"
    [showCloseButton]="true"
    [shading]="false"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box *ngIf="workAuthorizationEditor" width="100%" height="100%" direction="col" class="work-box-container">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-form width="100%" height="100%" labelLocation="top" [colCount]="1">
                        <dxi-item itemType="group" [colCount]="2">
                            <dxi-item>
                                <dxo-label text="Community"></dxo-label>
                                <div *dxTemplate>
                                    <dx-text-box
                                        [readOnly]="true"
                                        [value]="workAuthorizationEditor.communityName"
                                    ></dx-text-box>
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <dxo-label text="Work Order #"></dxo-label>
                                <div *dxTemplate>
                                    <div class="row-container">
                                        <div class="input-container">
                                            <dx-text-box
                                                [elementAttr]="{ class: 'text-content' }"
                                                [readOnly]="true"
                                                [value]="workAuthorizationEditor.workOrderId"
                                            ></dx-text-box>
                                        </div>
                                        <div
                                            *ngIf="isInternalUser"
                                            class="icon-content-container"
                                            (click)="onWorkAuthorizationNotesClick()"
                                        >
                                            <ng-container *ngIf="!workAuthorizationEditor.hasNotes">
                                                <i
                                                    class="fa-2x icon-content dx-theme-accent-as-text-color"
                                                    title="Internal Notes"
                                                    [ngClass]="iconEmptyNotes"
                                                ></i>
                                            </ng-container>
                                            <ng-container *ngIf="workAuthorizationEditor.hasNotes">
                                                <i
                                                    class="fa-2x icon-content cc-icon-check"
                                                    title="Internal Notes"
                                                    [ngClass]="iconNotes"
                                                ></i>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </dxi-item>
                        </dxi-item>

                        <dxi-item itemType="group" caption="Work Order Vendor Info" [colCount]="2">
                            <dxi-item [colSpan]="2">
                                <dxo-label text="Vendor"></dxo-label>
                                <div *dxTemplate>
                                    <dx-text-box
                                        [readOnly]="readOnlyVendor"
                                        [(value)]="workAuthorizationEditor.vendorName"
                                    >
                                        <ng-container *ngIf="!readOnlyVendor">
                                            <dxi-button
                                                name="search"
                                                location="after"
                                                [options]="{
                                                    type: 'default',
                                                    hint: 'Select Vendor',
                                                    icon: 'more',
                                                    onClick: onVendorSearchClick
                                                }"
                                            ></dxi-button>
                                        </ng-container>
                                    </dx-text-box>
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <!--
                                    NOTE: Design Upgrade
                                    In v1, without vendor, one can add and save vendor estimate.
                                    But in v2, without vendor, adding vendor estimate is restricted.
                                    Agreed with Sandeep Yeri and Murthy M.k on 3rd Sept 2022.
                                -->
                                <dxo-label text="Vendor Estimate"></dxo-label>
                                <div *dxTemplate>
                                    <dx-number-box
                                        min="0"
                                        [readOnly]="readOnlyVendor || !workAuthorizationEditor.vendorName"
                                        [(value)]="vendorEstimate"
                                        [format]="currencyFormat"
                                        (onValueChanged)="onVendorEstimateChanged($event)"
                                    ></dx-number-box>
                                </div>
                            </dxi-item>
                        </dxi-item>
                        <dxi-item itemType="group" caption="Work Authorization Info" [colCount]="1">
                            <dxi-item>
                                <div *dxTemplate>
                                    <dx-toolbar width="100%">
                                        <dxi-item location="before">
                                            <div *dxTemplate>
                                                <dx-drop-down-button
                                                    text="New Work Authorization"
                                                    hint="New Work Authorization"
                                                    displayExpr="displayText"
                                                    keyExpr="key"
                                                    [disabled]="!workAuthorizationEditor.vendorName"
                                                    [icon]="iconPlus"
                                                    [items]="actionItems"
                                                    (onItemClick)="onActionItemClick($event)"
                                                ></dx-drop-down-button>
                                            </div>
                                        </dxi-item>
                                        <dxi-item location="after">
                                            <div *dxTemplate>
                                                <dx-button
                                                    type="default"
                                                    text="Email Latest Work Authorization"
                                                    hint="Email Latest Work Authorization"
                                                    [disabled]="!workAuthorizationEditor.vendorName"
                                                    [icon]="iconEmail"
                                                    (onClick)="onEmailWorkAuthorization()"
                                                ></dx-button>
                                            </div>
                                        </dxi-item>
                                    </dx-toolbar>
                                </div>
                            </dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate class="grid-container dx-theme-border-color">
                    <cc-data-grid-features
                        [stateConfig]="{ storageKey: 'WORK_AUTHORIZATION_FILES', storeGroupings: true }"
                        [dataSource]="workAuthorizationFiles"
                    >
                        <dx-data-grid width="100%" height="100%" [dataSource]="workAuthorizationFiles">
                            <dxi-column dataField="fileName" dataType="string" caption="File Name"></dxi-column>
                            <dxi-column
                                dataField="generatedByUserDisplayText"
                                dataType="string"
                                caption="Generated By"
                                cellTemplate="generatedByUserDisplayTemplate"
                            ></dxi-column>
                            <dxi-column
                                dataField="generatedOn"
                                dataType="date"
                                caption="Generated On"
                                [format]="dateTimeFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="downloadUrl"
                                alignment="center"
                                caption=""
                                cellTemplate="fileDownloadTemplate"
                            ></dxi-column>

                            <div *dxTemplate="let r of 'generatedByUserDisplayTemplate'" class="responsible-container">
                                <ng-container
                                    [ngTemplateOutlet]="singleUserTemplate"
                                    [ngTemplateOutletContext]="{ data: r.data, user: r.data.generatedBy }"
                                ></ng-container>
                            </div>

                            <div *dxTemplate="let r of 'fileDownloadTemplate'">
                                <i
                                    class="cc-1-5x icon-content"
                                    title="Work Authorization Document"
                                    [ngClass]="getFileIcon(r.data)"
                                    (click)="onDownloadFile(r.data)"
                                ></i>
                            </div>
                        </dx-data-grid>
                    </cc-data-grid-features>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="toolbar-container">
                    <!-- 
                        NOTE: Design Upgrade
                        In v1, Save, SaveAndClose buttons are available. These buttons are used to save vendor estimate.
                        In v2, Save, SaveAndClose buttons are removed, as vendor estimate is saved as changed.
                        Agreed with Sandeep Yeri and Murthy M.K on 3rd Sept 2022.
                    -->
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Edit Work Order"
                                    hint="Edit Work Order"
                                    [icon]="iconEdit"
                                    (onClick)="onEditWorkOrderClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Manage Proposals"
                                    hint="Manage Proposals"
                                    (onClick)="onManageProposalsClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    hint="Close"
                                    [icon]="iconClose"
                                    (onClick)="onPopupClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<ng-template #singleUserTemplate let-user="user" let-data="data">
    <div class="res-content">
        <app-user-bio-link [user]="user" [communityId]="communityId"></app-user-bio-link>
    </div>
</ng-template>

<app-work-orders-notes-editor
    *ngIf="showNotes"
    [communityId]="communityId"
    [workOrderId]="workOrderId"
    (onClose)="onWorkAuthorizationNotesClose($event)"
></app-work-orders-notes-editor>

<app-select-vendor-for-proposal
    *ngIf="showAddVendor"
    selection="single"
    [communityId]="communityId"
    [workOrderId]="workOrderId"
    (onVendorSelection)="onVendorSelection($event)"
    (onClose)="onAddVendorProposalClose()"
></app-select-vendor-for-proposal>

<ng-container *ngIf="isInternalUser">
    <app-attachment-uploader
        *ngIf="showUploadManager"
        title="Manage Documents"
        [selectedAttachments]="workAuthorizationFiles"
        [communityId]="communityId"
        [customerId]="customerId"
        [allowDelete]="false"
        [communityApiUrl]="'api/workorder/community/documents/tree'"
        [ownerApiUrl]="'api/workorder/owner/documents/tree'"
        (onAttachmentUpdate)="onAttachmentUpdate($event)"
        (onClose)="onAttachmentUploaderClose()"
    ></app-attachment-uploader>
</ng-container>

<ng-container *ngIf="!isInternalUser">
    <app-attachment-uploader
        *ngIf="showUploadManager"
        [selectedAttachments]="workAuthorizationFiles"
        [allowDelete]="false"
        (onAttachmentUpdate)="onAttachmentUpdate($event)"
        (onClose)="onAttachmentUploaderClose()"
    ></app-attachment-uploader>
</ng-container>
